var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"width":"150px","value":_vm.onProgress}},[_c('v-card',{staticClass:"pa-3"},[_c('div',{staticClass:"content"},[_c('v-progress-circular',{attrs:{"size":80,"width":7,"color":_vm.color,"indeterminate":""}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }